module.exports = __webpack_public_path__ + "img/iconfont.751c2a6e.svg";